module.exports = __webpack_public_path__ + "img/UtilityTechBackgroundC05_ua.0a62fdbe.webp";